import "normalize.css/normalize.css"
import "date-input-polyfill"
import "core-js/actual/object/group-by"
import "core-js/actual/map/group-by"

import "./index.css"

if (typeof Promise.withResolvers === 'undefined') {
	Promise.withResolvers = <T>() => {
		let resolve!: (value: T | PromiseLike<T>) => void;
		let reject!: (reason?: unknown) => void;
		const promise = new Promise<T>((res, rej) => {
			resolve = res;
			reject = rej;
		});
		return { promise, resolve, reject };
	}
}

import { setupHostApp } from "~/host-app"

import { registerSW } from "virtual:pwa-register"

registerSW({
	immediate: true,
})

setupHostApp()